:host {
  /** @prop --start-color: the start color of the gradient on the skeleton (used for theming) */
  --start-color: rgba(0, 0, 0, 0.05);

  /** @prop --end-color: the end color of the gradient on the skeleton (used for theming) */
  --end-color: rgba(0, 0, 0, 0.15);

  display: block;
  border-radius: var(--wb-radius-s);
  background-size: 400%, 100%;
  animation: skeletonAnimation 6s linear infinite;
  background-image: linear-gradient(90deg, var(--start-color), var(--end-color), var(--end-color), var(--start-color));
}

:host([theme='dark']) {
  --start-color: rgba(255, 255, 255, 0.2);
  --end-color: rgba(255, 255, 255, 0.1);
}

:host([is-rtl]) {
  animation-direction: reverse;
}

@keyframes skeletonAnimation {
  0% {
    background-position: 200% 0%;
  }
  100% {
    background-position: -200% 0%;
  }
}
